import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCurDate, getDateString } from "../utils/DateTimeUtils";
import { DBManager } from "../db/dbManager";
import { DEBUG } from "../../../config";
import worker from "../setupWorker";
// import { sha256 } from "../../../lib/gramjs/Helpers";
import { sha256 } from "../db/crypto";
import { mergeTelemessage } from "../tdlib/tdlib";





const initialState = {
    chatsResult: [],
    messagesResult: {},
    newMessagesArived: []
}

export const tdlibSlice = createSlice({
    name: "tdlibSlice",
    initialState,
    //Khai báo các action bên trong reducers, các action để làm thay đổi state khi dispatch
    reducers: {
        addMessageToStore: (state, action) => {
            const { messages, chatId } = action.payload;
            const oldMessages = state.messagesResult[chatId]
            if (oldMessages == undefined)
                state.messagesResult[chatId] = messages
            else
                state.messagesResult[chatId].push(...messages)
        },
        removeMessageFromStore: (state, action) => {
            //state.messagesResult = {}
        }, // khi có tin nhắn mới
        addNewMessageToStore: (state, action) => {
            const { newMessage } = { ...action.payload }
            
            const func = async () => {

                //chỉ lưu các tin có text
                if (newMessage.content) {
                    if (newMessage.content.text) {
                        if (newMessage.content.text.text) {

                        } else {
                            return
                        }
                    } else {
                        return;
                    }
                } else {
                    return;
                }
                if (newMessage.chatId == '777000') // telegram
                    return;
                // if (newMessage.id%1!=0){
                //     return;//id không phải số nguyên, chưa phải là tin chính thức.
                // }
                const chatId = newMessage.chatId;
                // const id = Math.floor(copyMessage.id);
                mergeTelemessage(newMessage);
                const db = await DBManager.getDBConnection()
                const copyMessage = { ...newMessage }
                const keys = [chatId, newMessage.id]
                const result = await DBManager.readDataByPrimarykey("messages", keys)
                //console.log(result)
                if (result && result.length > 0) {
                    // if (DEBUG)
                    //     console.log("đã có tin nhắn nên không thêm")
                } else {
                    // if (DEBUG)
                    //     console.log("chưa có tin nhắn nên thêm mới vào index")



                    //console.log('ERROR new id=', copyMessage.id)
                    if (copyMessage.id % 1 > 0)
                        copyMessage.id = Math.ceil(copyMessage.id);


                    copyMessage.parsed = false;
                    // là tin đi, check đúp tin khi gửi tin đầu tiên
                    if (copyMessage.isOutgoing) {
                        const inputText = `${copyMessage.chatId}.${copyMessage.date}${copyMessage.content.text.text}`
                        const sha = await sha256(inputText)
                        copyMessage.textChecksum = sha

                        // const found = await DBManager.readDataByIndex("messages", copyMessage.textChecksum, "textChecksum")
                        // if (!found || found.length == 0) {
                            const trans = db.transaction("messages", "readwrite")
                            const objectStore = trans.objectStore("messages")
                            objectStore.put(copyMessage)
                        // } else {
                        //     if (DEBUG)
                        //         console.log("duplicate message", copyMessage)
                        // }
                    } else {
                        const trans = db.transaction("messages", "readwrite")
                        const objectStore = trans.objectStore("messages")
                        objectStore.put(copyMessage)
                    }

                    //trans.commit()
                    worker.postMessage({ type: 'parse', payload: copyMessage })
                    if (DEBUG) {
                        console.log("new inbox message send to worker", copyMessage)
                    }
                }
            }
            func();
            if (newMessage.id > 1) {
                state.newMessagesArived.push(newMessage)
                if (DEBUG)
                    console.log("new message added to store", newMessage.id)
            }

        },
        onMessageEdited: (state, action) => {
            const { editedMessage } = action.payload
            const chatId = editedMessage.chatId;
            const id = editedMessage.id;
            if (editedMessage.isEdited) {
                DBManager.getDBConnection().then(db => {
                    const keys = [chatId, id]
                    const trans = db.transaction("editedMessages", "readwrite")
                    const objectStore = trans.objectStore("editedMessages")
                    objectStore.put(editedMessage)
                })
            }
            //console.log("telegram message edited ", action.payload)
        },
        onMessageDeleted: (state, action) => {

            const { deletedMessage } = action.payload
            if (!deletedMessage)
                return;
            const chatId = deletedMessage.chatId;
            const id = deletedMessage.id;
            DBManager.getDBConnection().then(db => {
                const keys = [chatId, id]
                const trans = db.transaction("deletedMessages", "readwrite")
                const objectStore = trans.objectStore("deletedMessages")
                objectStore.put(deletedMessage)
            })
        },
        onNewMessageNotiProcessed: (state, action) => {
            const tmp = state.newMessagesArived
            let length = tmp.length - 1
            if (length == 0 && tmp.length == 1)
                length = 1
            tmp.splice(0, length)
            state.newMessagesArived = tmp
        }
    },
    extraReducers: (builder) => {

    }
});

export const { addMessageToStore, onNewMessageNotiProcessed,
    removeMessageFromStore, addNewMessageToStore, onMessageDeleted, onMessageEdited } = tdlibSlice.actions;
export default tdlibSlice.reducer;